import React, { memo } from "react";

const MessageAudio = props => {
  const { sound, containerStyle = {} } = props;

  return (
    <div style={containerStyle}>
      <div style={styles.audioContainer}>
        <audio controls>
          <source src={sound} type="audio/mpeg" />
          Your browser does not support the audio element.
        </audio>
      </div>
    </div>
  );
};

export default memo(MessageAudio);

const styles = {
  audioContainer: {
    display: "flex",
    alignItems: "center",
    maxWidth: 350,
  },
};
